import { render, staticRenderFns } from "./SeckillSessionEdit.vue?vue&type=template&id=08f08ce4&scoped=true"
import script from "./SeckillSessionEdit.vue?vue&type=script&lang=js"
export * from "./SeckillSessionEdit.vue?vue&type=script&lang=js"
import style0 from "./SeckillSessionEdit.vue?vue&type=style&index=0&id=08f08ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f08ce4",
  null
  
)

export default component.exports